import React, { useState } from 'react';
import { Fingerprint, Loader2, Mail } from 'lucide-react';
import { toast } from 'sonner';
import { startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser';
import { errMsg } from '../portal/api';
import { K, btn, field, gold, saveSession, tapi } from './tapi';

export default function TravelerLogin({ onIn }) {
  const known = localStorage.getItem(K.email) || '';
  const [email, setEmail] = useState(known);
  const [code, setCode] = useState('');
  const [step, setStep] = useState('email');
  const [busy, setBusy] = useState('');
  const run = async (k, fn) => { setBusy(k); try { await fn(); } catch (e) { toast.error(e.name === 'NotAllowedError' ? 'Verifica annullata' : errMsg(e)); } finally { setBusy(''); } };
  const bio = () => run('bio', async () => {
    const { data } = await tapi.post('/passkey/auth/options', { email });
    const credential = await startAuthentication({ optionsJSON: data.options });
    const r = await tapi.post('/passkey/auth/verify', { challenge_id: data.challenge_id, credential });
    saveSession(r.data); onIn(r.data);
  });
  const send = () => run('send', async () => { await tapi.post('/otp/start', { email }); setStep('code'); toast.success("Se l'indirizzo è associato a una trasferta riceverai un codice via email"); });
  const verify = () => run('verify', async () => { const r = await tapi.post('/otp/verify', { email, code }); saveSession(r.data); onIn(r.data); });
  return (
    <div className="space-y-4" data-testid="traveler-login">
      <h1 className="text-2xl font-semibold">Accedi all'app viaggiatore</h1>
      <p className="text-sm text-[#A3A3A3]">Usa l'email indicata dalla tua azienda per la trasferta.</p>
      <input type="email" value={email} onChange={(e) => setEmail(e.target.value.trim())} placeholder="La tua email" className={field} data-testid="traveler-email" />
      {known && localStorage.getItem(K.bio) === '1' && browserSupportsWebAuthn() && step === 'email' && (
        <button onClick={bio} disabled={!!busy || !email} className={btn} style={gold} data-testid="traveler-bio-login">{busy === 'bio' ? <Loader2 className="animate-spin" size={18} /> : <Fingerprint size={20} />}Accedi con Face ID / impronta</button>)}
      {step === 'email'
        ? <button onClick={send} disabled={!!busy || !email.includes('@')} className={`${btn} border border-[#D4AF37] text-[#D4AF37]`} data-testid="traveler-send-code">{busy === 'send' ? <Loader2 className="animate-spin" size={18} /> : <Mail size={18} />}Ricevi il codice via email</button>
        : <>
          <input inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} placeholder="Codice di 6 cifre" className={`${field} tracking-[0.4em] text-center`} data-testid="traveler-code" />
          <button onClick={verify} disabled={!!busy || code.length !== 6} className={btn} style={gold} data-testid="traveler-verify-code">{busy === 'verify' && <Loader2 className="animate-spin" size={18} />}Accedi</button>
          <button onClick={() => setStep('email')} className="text-sm text-[#A3A3A3] underline w-full" data-testid="traveler-back">Cambia email</button>
        </>}
    </div>
  );
}
